import React from 'react';
import { motion } from 'framer-motion';
import { Mode } from '../../types';
import { cn } from '../../lib/utils';
import { Building2, User } from 'lucide-react';
interface ModeToggleProps {
  mode: Mode;
  onToggle: (mode: Mode) => void;
}
export function ModeToggle({
  mode,
  onToggle
}: ModeToggleProps) {
  return <div className="relative flex items-center bg-slate-100 rounded-full p-1 w-fit" data-id="element-99">
      <motion.div className="absolute left-1 top-1 bottom-1 w-[calc(50%-4px)] bg-white rounded-full shadow-sm border border-slate-200/50" initial={false} animate={{
      x: mode === 'business' ? 0 : '100%'
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 30
    }} data-id="element-100" />

      <button onClick={() => onToggle('business')} className={cn('relative z-10 px-2 sm:px-4 py-1.5 text-xs sm:text-sm font-medium transition-colors duration-200 rounded-full flex items-center gap-1.5', mode === 'business' ? 'text-slate-900' : 'text-slate-500 hover:text-slate-700')} data-id="element-101">
        <Building2 className="w-3.5 h-3.5 sm:hidden" data-id="element-102" />
        <span className="hidden sm:inline" data-id="element-103">For Business</span>
        <span className="sm:hidden" data-id="element-104">Business</span>
      </button>

      <button onClick={() => onToggle('individual')} className={cn('relative z-10 px-2 sm:px-4 py-1.5 text-xs sm:text-sm font-medium transition-colors duration-200 rounded-full flex items-center gap-1.5', mode === 'individual' ? 'text-slate-900' : 'text-slate-500 hover:text-slate-700')} data-id="element-105">
        <User className="w-3.5 h-3.5 sm:hidden" data-id="element-106" />
        <span className="hidden sm:inline" data-id="element-107">For Individuals</span>
        <span className="sm:hidden" data-id="element-108">Personal</span>
      </button>
    </div>;
}